import { Box, Stack, styled, TextField } from '@mui/material';

export const ChipsWrapper = styled(Stack)`
  flex-wrap: wrap;
  flex-direction: row;
  gap: 8px;
`;

export const TextFieldTag = styled(TextField)`
  border-radius: 6px;
  background: ${({ theme }) => theme.palette.primary.main};
  justify-content: center;

  .MuiInputBase-input {
    color: ${({ theme }) => theme.palette.primary.contrastText};
    font-size: 13px;
    font-weight: 400;
    line-height: 20.02px;
    letter-spacing: 0.17px;
    padding: 2px 8px;
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;

export const DummySpan = styled('span')`
  position: absolute;
  white-space: pre;
  visibility: hidden;
  font-size: 13px;
  font-weight: 400;
  line-height: 20.02px;
  letter-spacing: 0.17px;
  padding: 2px 8px;
`;

export const TranscriptList = styled(Box)`
  height: 510px;
  overflow-y: auto;
`;
